var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"payment-card-logo-container"},[_c('div',{directives:[{name:"bg-img",rawName:"v-bg-img",value:(_vm.creditCardLogoUrl),expression:"creditCardLogoUrl"}],staticClass:"logo"})])
}
var staticRenderFns = []

export { render, staticRenderFns }